import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Layout } from 'antd';
import { useNavigate } from 'react-router-dom';

import { MenuActions } from 'src/Redux';
import { routerPath } from 'src/Config';
import { PartMenu, UserSelectContainer } from './index';
import { CustomIcon, useGetWindowSize, trb, i18 } from 'src/Utilities';

const { Sider } = Layout;

export const PartSwapMenu = () => {
  const dispatch = useDispatch();
  const windowSize = useGetWindowSize();
  const navigate = useNavigate();
  const { menuCollapsed, contentMenu, contentMenuPath } = useSelector((state) => state.MenuReducer);
  const { language } = useSelector((state) => state.languageReducer);

  const [logo, setLogo] = useState(`${import.meta.env.VITE_ROOT}images/logos/${menuCollapsed ? import.meta.env.VITE_LOGO : import.meta.env.VITE_LOGO_COLLAPSED}`);
  const [isAnimating, setIsAnimating] = useState(false);

  const toggle = () => {
    setIsAnimating(true);
    dispatch(MenuActions.toggle());
  };

  useEffect(() => {
    const delay = menuCollapsed ? 0 : 300;
    const timer = setTimeout(() => {
      setLogo(`${import.meta.env.VITE_ROOT}images/logos/${menuCollapsed ? import.meta.env.VITE_LOGO : import.meta.env.VITE_LOGO_COLLAPSED}`);
      setIsAnimating(false);
    }, delay);

    return () => clearTimeout(timer);
  }, [menuCollapsed]);

  const getLogoStyle = () => ({
    transition: 'all 0.3s ease-in-out',
    transform: isAnimating ? `scale(${menuCollapsed ? 0.9 : 1.1})` : 'scale(1)',
    maxWidth: '100%',
    height: 'auto',
  });

  return (
    <Sider
      className={`menu-sider ${menuCollapsed ? 'menu-collapsed' : ''}`}
      width={265}
      style={{
        height: menuCollapsed && windowSize.mobileCheck ? windowSize.height - 50 : 'auto',
        transition: 'all 0.3s ease-in-out',
      }}
      collapsedWidth={85}
      theme="light"
      collapsed={windowSize.mobileCheck ? null : !menuCollapsed}
    >
      <div className="d-flex flex-column h-100 justify-content-between">
        <div>
          <div className="eb_menu_logo">
            <img
              src={logo}
              id="logo"
              alt={import.meta.env.VITE_TITLE}
              onClick={() => navigate(routerPath.index)}
              className="cursor-pointer"
              style={getLogoStyle()}
            />
          </div>
          <div className="eb_menu_mobile d-flex d-md-none">
            <UserSelectContainer />
            <Button
              id="SidebarMobileSettingsButton"
              className="text-click"
              onClick={() => {
                toggle();
                navigate(routerPath.settings);
              }}
              type="link"
              aria-label={trb(i18.Menu.Settings)}
            >
              <CustomIcon
                type="custom"
                icon="settings"
              />
            </Button>
          </div>
          <div className="eb_menu_btn_collapse_wrapper">
            <Button
              id="SidebarCollapseButton"
              type="link"
              onClick={toggle}
              className={`eb_menu_btn_collapse text-left width-40 ${menuCollapsed ? 'pr-20' : 'pl-20'}`}
              icon={
                <CustomIcon
                  size={12}
                  type="custom"
                  icon="caretLeft"
                  className={!menuCollapsed ? 'rotate-180' : ''}
                />
              }
              aria-label={trb(i18.Accessibility.MenuCollapse)}
            />
          </div>
          <PartMenu
            toggleMenu={toggle}
            language={language}
            menuCollapsed={menuCollapsed}
            contentMenu={contentMenu}
            contentMenuPath={contentMenuPath}
          />
        </div>
      </div>
    </Sider>
  );
};
